import { injectGlobal } from "styled-components";
import { typography, colors } from "./";

injectGlobal`
  html {
    height: 100%;
  }

  body {
		// font-family: 'Rubik', sans-serif;
    // font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    font-family: 'Poppins', sans-serif;
    margin: 0;
    font-size: ${typography.fontSizeBody}px;
    line-height: ${typography.lineHeightBody};
    color: ${colors.textPrimary};
    height: 100%;
    background: ${colors.bgMain};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: 100%;

    > #root {
      display: flex;
      flex: 1;
      height: 100%;
    }
  }

  a {
    color: ${colors.linkPrimary};
    transition: color 0.3s ease;
  }

  a:hover {
    color: inherit;
    text-decoration: none;
  }

  .text-primary {
    color: ${colors.colorPrimary} !important;
  }

  .text-success {
    color: ${colors.colorCoreGreen} !important;
  }

  .text-warning {
    color: ${colors.colorCoreYellow} !important;
  }
  .text-blue {
    color: ${colors.themeBlue} !important;
  }
  /* override */


  .FModal .modal-dialog {
    // width: max-content;
    margin: 0px auto;
  }
  .FModal .modal-body {
    padding: 20px;
  }
  // .modal.right .modal-dialog {
	// 	position: fixed;
	// 	margin: auto;
	// 	width: 40%;
  //   min-width: 400px;
	// 	height: 100%;
	// 	-webkit-transform: translate3d(0%, 0, 0);
	// 	    -ms-transform: translate3d(0%, 0, 0);
	// 	     -o-transform: translate3d(0%, 0, 0);
	// 	        transform: translate3d(0%, 0, 0);
	// }

  // .modal.right .modal-content {
	// 	height: 100%;
	// 	// overflow-y: auto;
  //   background: #fff;
	// }

  // .modal.right .modal-body {
	// 	padding: 40px 25px 30px 25px;
  //   max-height: 82%;
  //   height: 100%;
  //   overflow-y: auto;
	// }

  // .modal.right.fade .modal-dialog {
	// 	right: -320px;
	// 	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	// 	   -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	// 	     -o-transition: opacity 0.3s linear, right 0.3s ease-out;
	// 	        transition: opacity 0.3s linear, right 0.3s ease-out;
	// }

	// .modal.right.fade.in .modal-dialog {
  //   top: 0;
	// 	right: 0;
	// }

  .right {
    top: 10px !important;
    left: 0 !important;
  }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .modal {
    // top: 20px;
    bottom: 20px;

  }

  .modal.fade.in .modal-dialog {
    // top: 20%;
    top: 20px;
    // bottom: 20px;
    // width: 70%;
  }
  @media (max-width: 767px) {
    .modal.fade.in .modal-dialog {
        top: 6%;
    }
}

  .modal.center.fade.in .modal-dialog {
    top: 20%;
    width: 400px;
  }

  .modal.center .modal-body {
		padding: 30px 25px 30px 25px;
	}

  .modal.center label {
    font-weight: 600;
    color: #343434;
    font-size: 18px;
    text-transform: capitalize;
  }

  .modal-backdrop {
    background-color: #30435C;
  } !important

  .modal-backdrop.in {
    opacity: 0.8;
  }

  .modal-dialog {
    // padding-top: 50px;
    padding-buttom: 10px;
    // padding: 50px 0;
    margin: 0 auto;
    // height: 560px;
  }

  .modal-dialog.full {
    width: 85%;
  }

  .overflowNot .modal-body {
    overflow-y: inherit;
    overflow-x: inherit;
  }

  .modal-content {
    border-radius: 10px;
    border: 0;
    box-shadow: 0 2px 10px -3px rgba(0, 0, 0, 0.5);
    // background: ${colors.bgLight};
    height: auto;
  }

  .modal-header {
    padding: 23px 30px;
    height: 70px;
    border: 0;
    border-radius: 10px 10px 0px 0px;
    background: #eef3fa;
    box-shadow: 0px 4px 4px rgba(2, 51, 114, 0.01);
  }

  .modal-header .close {
    outline: 0;
  }

  .modal-title {
    font-size: ${typography.fontSizeHeading10}px;
    font-weight: 600;
    color: ${colors.themeBlack};
    text-align: center;
  }

  .modal-body {
    @media (max-width: 760px )
    {
      max-height: calc(100vh - 160px);
    }
    // padding: 40px 40px 40px 40px;
    // background: ${colors.colorWhite};
    border-radius: 0px 0px 50px 50px;
    padding: 40px 25px 70px 25px;
    overflow-y: auto;
    overflow-x: auto;
    // max-height: 450px;
    max-height: calc(100vh - 110px);
  }

  .modal-footer {
    padding: 0;
    margin-top: 40px;
    border: none;
  }

  .close {
    font-weight: ${typography.fontWeightLight};
    text-shadow: none;
    color: ${colors.themeBlack};
    opacity: 1;
    font-size: 34px;
    line-height: 25px;
  }

  .close:hover {
    opacity: 1;
    color: ${colors.themeBlue};
  }

  .customer-form {
    width: 70%;
  }

  .auto-churn {
    width: 50%;
  }

  @media (max-width: 760px ) {

    .auto-churn {
      width: 100%;
    }

  }

  /* dropdow */

  .dropdown-menu {
    margin-top: 0 !important;
    border-radius: 0;
    border: none;
    font-size: ${typography.fontSizeBody}px;
    color: ${colors.textPrimary};
    min-width: 100%;
    box-shadow: 0 5px 15px 1px rgba(0, 0, 0, 0.15);
  }

  .dropdown-menu > span {
    display: block;
  }

  .dropdown-menu li a {
    display: block;
    padding: 3px 10px;
    color: ${colors.textPrimary};
    white-space: nowrap;
    float: none;
    margin: 0;
  }

  .dropdown-menu > li > a {
    color: ${colors.textPrimary};
    font-weight: normal;
  }

  .dropdown-menu > li > a:focus,
  .dropdown-menu > li > a:hover,
  .dropdown-menu li a:focus,
  .dropdown-menu li a:hover {
    color: ${colors.colorCoreDarkGray};
    background: ${colors.bgActive};
    outline: 0;
    cursor: pointer;
  }

  /* tooltip */
  .tooltip {
    // font-family: 'Rubik', sans-serif;
    // font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    font-family: 'Poppins', sans-serif;
  }

  .tooltip-inner {
    background-color: ${colors.colorWhite};
    color: ${colors.colorCoreDarkGray};
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.23);
  }

  .tooltip.bottom .tooltip-arrow, {
    border-bottom-color: ${colors.colorWhite};
  }

  .tooltip.top .tooltip-arrow {
    border-top-color: ${colors.colorWhite};
  }

  .tooltip.left .tooltip-arrow {
    border-left-color: ${colors.colorWhite};
  }

  .tooltip.right .tooltip-arrow {
    border-right-color: ${colors.colorWhite};
    border-width: 0px 10px 13px 0;
    margin-top: 0;
    top: 0 !important;
  }

  .tooltip.right .tooltip-inner {
    border-top-left-radius: 0;
  }

  .tooltip.in {
    opacity: 1;
  }

  .tooltip.right {
    padding: 0 5px 0 6px;
  }

  /* popover */

  .popover {
    // font-family: 'Rubik', sans-serif;
    // font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    font-family: 'Poppins', sans-serif;
    border: none;
    border-radius: 0;
    font-size: inherit;
    padding: 0;
    color: ${colors.textPrimary};
    font-weight: inherit;
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.15);
    max-width: 310px;
  }

  .popover.bottom > .arrow {
    border-bottom-color: ${colors.borderPrimary};
  }

  .popover.bottom > .arrow::after {
    top: 1px;
    border-bottom-color: ${colors.bgLight};
  }

  .popover > .arrow {
    border-width: 10px;
  }

  .popover.top > .arrow {
    bottom: -10px;
    margin-left: -10px;
    border-top-color: ${colors.borderPrimary};
  }

  .popover.top > .arrow::after {
    bottom: 1px;
    border-top-color: ${colors.colorWhite};
  }

  .popover-title {
    display: block;
    border-bottom: 1px solid ${colors.borderPrimary};
    padding: 10px 20px;
    background: ${colors.bgLight};
    font-size: ${typography.fontSizeUppercase}px;
    text-transform: uppercase;
    color: ${colors.colorCoreGray};
    border-radius: 0;
  }

  .popover-content {
    padding: 0;
    position: relative;
    min-width: 260px;
  }

  .popover-content .chrome-picker {
    width: 100% !important;
    box-shadow: none !important;
  }

  .popover-content ul {
    max-height: 280px;
    overflow: auto;
  }

  .popover-content li a i {
    margin-left: 0;
  }

  .popover-template {
    max-width: 405px;
    width: 405px;
    height: 400px;
  }
  .popover-template .popover-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 33px;
  }

  .notification-popover {
    right: 15px;
    max-width: 360px;
  }

  /* select  */

  .Select-control {
    border-radius: 4px;
    border: none;
    border: 1px solid ${colors.colorPrimary};
    box-shadow: none;
    background: none;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .Select-control:hover {
    cursor: pointer;
    box-shadow: none;
  }

  .Select-placeholder {
    // line-height: 50px;
    display: flex;
    align-items: center;
  }

  .Select.is-focused > .Select-control,
  .Select.is-open > .Select-control {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-color: ${colors.themeBlack};
    background: none;
  }

  .Select.is-focused:not(.is-open) > .Select-control {
    box-shadow: none;
    background: none;
    border-color: ${colors.themeBlack};
  }

  .Select.is-focused .Select-input > input {
    padding: 10px 0 12px;
  }

  .Select-placeholder,
  .Select-input,
  .Select--single > .Select-control .Select-value {
    padding-left: 10px;
    padding-right: 10px;
    // line-height: 50px;
    display: flex;
    align-items: center;
  }

  .Select .Select-input .form-invalid  {
    border: 1px solid #EA475D;
    margin-top: -8px;
    margin-left: -22px;
    /* position: absolute; */
    width: 162% !important;
    height: 28px;
    border-radius: 4px;
  }


  .Select-clear {
    font-size: ${typography.fontSizeHeading6}px;
    line-height: 1.4;
    margin-top: 1px;
  }

  .Select-clear-zone:hover {
    color: ${colors.colorCoreRed};
  }

  .Select--multi .Select-multi-value-wrapper {
    padding: 0 5px;
  }

  .Select--multi .Select-input {
    margin-left: 5px;
  }

  .Select--multi .Select-value {
    background-color: ${colors.colorPrimary};
    border-radius: 11px;
    border: 1px solid ${colors.colorPrimary};
    color: ${colors.colorWhite};
    margin-top: 6px;
    margin-left: 0;
    margin-right: 5px;
    position: relative;
    padding-right: 20px;
  }

  .Select--multi .Select-value-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: absolute;
    right: 0;
    top: 0;
    text-align: center;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.1);
    padding: 0;
  }

  .Select--multi .Select-value-icon:hover,
  .Select--multi .Select-value-icon:focus,
  .Select--multi .Select-value-icon:active {
    background-color: rgba(0, 0, 0, 0.2);
    color: ${colors.colorWhite};
  }

  .Select--multi .Select-value-label {
    padding: 2px 10px;
  }

  .Select--multi.has-value .Select-input {
    margin-left: 5px;
  }

  .Select--multi a.Select-value-label {
    color: ${colors.colorPrimaryDark};
  }

  .Select-arrow-zone {
    padding-right: 10px;
  }

  .Select-arrow-zone > .Select-arrow {
    border: none;
    margin-right: 10px;
  }

  .Select .Select-arrow:before {
    font-family: 'erxes';
    font-size: 10px;
    content: '\\e827';
    color: ${colors.colorPrimary};
  }

  .Select.is-open .Select-arrow:before {
    content: '\\e89a';
  }

  .Select-menu-outer {
    border: none;
    margin-top: 1px;
    box-shadow: 0 5px 15px 1px rgba(0, 0, 0, 0.15);
  }

  .Select-menu-outer, .Select-option:last-child {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .Select-option-group-label {
    background-color: ${colors.bgLight};
    color: #666;
    border-bottom: 1px solid ${colors.borderPrimary};
    border-top: 1px solid ${colors.borderPrimary};
    font-weight: ${typography.fontWeightMedium};
    text-transform: uppercase;
    padding: 8px 12px;
  }

  .Select-option-group-label ~ .Select-option {
    padding-left: 20px;
  }

  .Select-option-group-label .Select-option-group {
    padding-left: 20px;
  }

  .Select-option {
    padding: 8px 12px;
  }

  .Select-noresults {
    padding: 8px 12px;
  }

  .simple-option .channel-round {
    color: ${colors.colorWhite};
    font-weight: bold;
    width: 20px;
    height: 20px;
    float: right;
    border-radius: 10px;
    background: ${colors.colorCoreYellow};
    text-align: center;
    font-size: 10px;
    line-height: 20px;
    cursor: pointer;
  }

  /* react toggle */

  .react-toggle--checked .react-toggle-track {
    background-color: ${colors.colorCoreGreen};
  }

  .react-toggle-track {
    background-color: ${colors.colorCoreBlack};
    width: 30px !important;
    height: 15px !important;
  }

  .react-toggle-track span {
    display: none;
  }

  .react-toggle-thumb {
    width: 13px !important;
    height: 13px !important;
  }

  .react-toggle--checked .react-toggle-thumb,
  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    border-color: ${colors.colorCoreGreen};
    left: 15px !important;
  }

  /* punch card */

  .punch-card .axis path,
  .punch-card .axis line {
    fill: none;
    stroke: ${colors.colorCoreGray};
    stroke-width: 1px;
    shape-rendering: crispEdges;
  }
  .punch-card .axis text {
    font-size: 0.875em;
    fill: ${colors.colorCoreGray};
  }

  /* react datetime */

  .rdtPicker {
    box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.15);
    width: 100%;
    border-color: ${colors.colorShadowGray};
    min-width: 200px;
    max-width: 260px;
  }

  .rdtPicker td.rdtToday:before {
    border-bottom: 7px solid ${colors.colorPrimary} !important;
  }

  .rdtPicker td.rdtActive,
  .rdtPicker td.rdtActive:hover {
    background-color: ${colors.colorPrimary} !important;
  }

  .rdtPicker th,
  .rdtPicker tfoot {
    border-color: ${colors.borderPrimary};
  }

  /* editor */
  .RichEditor-editor .public-DraftEditor-content ul {
    padding-left: 25px;
  }

  .RichEditor-editor .public-DraftEditor-content ol {
    padding-left: 25px;
  }

  .RichEditor-editor .public-DraftEditor-content h3 {
    margin-top: 0;
  }

  .RichEditor-editor .RichEditor-blockquote {
    border-left: 5px solid ${colors.borderDarker};
    color: ${colors.colorCoreGray};
    font-style: italic;
    padding: 10px 20px;
  }

  .RichEditor-editor .public-DraftStyleDefault-pre {
    margin-bottom: 0;
  }
  .RichEditor-editor .public-DraftStyleDefault-pre pre {
    padding: 0;
    margin: 0;
    border: 0;
  }

  .RichEditor-hidePlaceholder .public-DraftEditorPlaceholder-root {
    display: none;
  }

  /* mention */
  .draftJsMentionPlugin__mention__29BEd {
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
    border-radius: 4px;
    text-decoration: none;
  }

  .draftJsMentionPlugin__mention__29BEd:visited {
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
    text-decoration: none;
  }

  .draftJsMentionPlugin__mention__29BEd:hover {
    outline: 0;
  }

  .draftJsMentionPlugin__mention__29BEd:focus {
    outline: 0;
  }

  .draftJsMentionPlugin__mention__29BEd:active {
    color: ${colors.colorCoreDarkGray};
  }

  .draftJsMentionPlugin__mentionSuggestions__2DWjA {
    position: absolute;
    min-width: 220px;
    width: 100%;
    background: ${colors.colorWhite};
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 2000;
    box-sizing: border-box;
    transform: scale(0);
    bottom: 100%;
    top: auto !important;
    left: 0 !important;
    max-height: 300px;
    overflow: auto;
  }

  .draftJsMentionPlugin__mentionSuggestionsEntry__3mSwm {
    padding: 5px 10px;
    transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);
    font-size: ${typography.fontSizeBody}px;
  }

  .draftJsMentionPlugin__mentionSuggestionsEntry__3mSwm:active {
    background-color: ${colors.borderPrimary};
  }

  .draftJsMentionPlugin__mentionSuggestionsEntryFocused__3LcTd {
    background-color: ${colors.bgUnread};
  }

  .mentioned-person {
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
    text-decoration: none;
  }

  .mention {
    text-decoration: none;
  }

  .mentionSuggestionsEntryContainer {
    display: flex;
  }

  .mentionSuggestionsEntryContainerRight {
    display: flex;
    padding-left: 8px;
    flex: 1;
    flex-direction: row;
    align-items: center;
  }

  .mentionSuggestionsEntryText,
  .mentionSuggestionsEntryTitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mentionSuggestionsEntryText {
    margin-right: 8px;
    font-weight: bold;
  }

  .mentionSuggestionsEntryTitle {
    font-size: 95%;
    color: ${colors.colorCoreGray};
    margin-top: 2px;
  }

  .mentionSuggestionsEntryAvatar {
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  /* other */
  .sidebar-accordion {
    border-top: 1px solid ${colors.borderPrimary};
    border-bottom: 1px solid ${colors.borderPrimary};
    margin-bottom: 10px;

    ul {
      padding-top: 0;
      max-height: none;
    }
  }

  .sidebar-accordion .popover-header {
    background: none;
  }

  .sidebar-accordion .popover-list {
    max-height: none;
  }

  /* icon select */

  .icon-option {
    display: flex;
    align-items: center;
  }

  .icon-option i {
    margin-right: 10px;
    font-size: ${typography.fontSizeHeading6}px;
    color: ${colors.colorPrimaryDark};
  }

  /* scrollbar */

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 0;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(72, 77, 61, .6);
    border-radius: 0;
    border: 1px solid ${colors.borderDarker};
  }

  ::-webkit-scrollbar-track {
    background: rgba(215, 215, 215, .35);
  }
  .cursorPointer {
    cursor: pointer;
  }


  .ag-theme-alpine {
    border: none;
  }
  .ag-header-cell-label {
    color: #0161ED;
    font-size: 14px;
    font-weight: 600;
  }

  .ag-theme-alpine .ag-header-cell-resize::after {
    width: 0px !important;
  }

  .ag-theme-alpine .ag-header {
    background: none !important;
  }

  .ag-theme-alpine .ag-cell {
    border: none;
    color: #444;
    padding: 10px;
    display: table-cell;
    font-size: 14px;
    padding: 10px 20px;
    line-height: normal !important;
  }

  .ag-theme-alpine .ag-row {
    border: none !important;
  }

  .ag-theme-alpine .ag-root-wrapper {
    border: none !important;
    border-color: #D6D6D6 !important;
  }

  .ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-cell, .ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {
    border-color: #D6D6D6 !important;
  }

  .styleTag {
    border-radius: 14px;
    padding: 3px 9px;
    text-transform: uppercase;
    white-space: nowrap;
    font-size: 8px;
    line-height: 1.32857;
    border: none;
    font-weight: 600;
    animation: 0s ease 0s 1 normal none running none;
  }

  .editorClassName.rdw-editor-main {
    border: 1px solid #F1F1F1 !important;
    padding: 5px !important;
    border-radius: 2px !important;
  }

  a#uncontrolled-tab-example-tab-sms, a#uncontrolled-tab-example-tab-email {
    color: ${colors.themeBlack};
    font-weight: 600;
    font-size: 14px;
  }

  .borderRight th {
    border-right: 1px solid #D6D6D6 !important;
  }

  .borderRight th:last-child {
    border-right: none !important;
  }

  // ul.nav.nav-tabs{
  //   border: none;
  // }
  // #uncontrolled-tab-example-tab-1{
  //   border: none;
  // }
  // #uncontrolled-tab-example-tab-1.active{
  //   border: none;
  //   background:purple;
  // }
  // #uncontrolled-tab-example-tab-2{
  //   border: none;
  //   margin-left: 16px;
  // }
  // #uncontrolled-tab-example-tab-3{
  //   border: none;
  //   margin-left: 16px;
  // }
  // .nav-tabs>li>a{
  //   color:#fff;
  //   font-family: 'Poppins';
  //   font-style: normal;
  //   font-weight: 600;
  //   font-size: 16px;
  //   line-height: 22px;
  //   // background-color:blue;
  //   background: grey;
  //   background: #f4fbfd;
  //   color:#000;
  //   // opacity: 0.05;
  //   border-radius: 6px;
  //   outline:none;
  // }

  // // .nav-tabs>li.active{
  // //   color:green;
  // // }

  // // .nav-tabs>li>a:hover{
  // //   background-color:yellow;
  // // }

  // .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover{
  //   background-color:#28A6DE !important;
  //   color:#fff;
  //   outline:none;
  // }

  // .nav-tabs>li>a:visited{
  //   color:#fff;
  //   font-family: 'Nunito';
  //   font-style: normal;
  //   font-weight: 700;
  //   font-size: 16px;
  //   line-height: 22px;
  //   // background-color:blue;
  //   background: #28A6DE;

  //   // opacity: 0.05;
  //   border-radius: 6px;
  // }

  // .nav>li>a:focus, .nav>li>a:hover{
  //   background-color:gray;
  //   background: #f4fbfd;
  //   outline: none;
  // }
`;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/styles/global-styles.js